
import { defineComponent } from 'vue';
import Child from './Child.vue';
export default defineComponent({
    name: 'Parent',
    components: {
        Child,
    },
    props: {

    }
});
